import { useFetchCb } from '@gluedigital/ruse-fetch-extras'
import { CATALOG_URL } from 'src/constants/global'

interface UploadImageResponse {
  ok: boolean
  id: string
}

export default function useUploadImage() {
  const doFetch = useFetchCb()

  return async (file: File): Promise<string> => {
    const body = new FormData()
    body.append('file', file)
    const res = (await doFetch(CATALOG_URL + '/v1/images', {
      method: 'POST',
      body
    })) as UploadImageResponse

    return res.id
  }
}
